module.exports = __webpack_public_path__ + "static/media/physical_logo.dcb4fd6d.png";